<div class="container col-12 mt-3" *ngIf="solicitud && solicitud.codigoCertificado && solicitudPoliza">
    <ca-card ui-3 class="md-5" >
        <div ca-card-title>{{'DATOS_SOLICITUD.DETALLE_POLIZA' | translate}}</div>
        <div ca-card-content>
            <div class="row"> 
                <ca-form-field class="col-4">
                    <ca-label>{{'DATOS_SOLICITUD.CERTIFICADO' | translate}}</ca-label>
                    <input caInput type="text" disabled [value]="solicitud.codigoCertificado"/>
                </ca-form-field>
                <ca-form-field class="col-4">
                    <ca-label>{{'DATOS_SOLICITUD.NUM_POL_COL' | translate}}</ca-label>
                    <input caInput type="text" disabled [value]="solicitud.codigoColectiva"/>
                </ca-form-field>
            </div>
            <div class="row mt-3"> 
                <ca-form-field class="col-4">
                    <ca-label>{{'DATOS_SOLICITUD.FECHA_EFECTO' | translate}}</ca-label>
                    <input caInput type="text" disabled [value]="mostrarFecha(solicitudPoliza.poliza?.fechaEfecto)"/>
                </ca-form-field>
                <ca-form-field class="col-4">
                    <ca-label>{{'DATOS_SOLICITUD.FECHA_VTO' | translate}}</ca-label>
                    <input caInput type="text" disabled [value]="mostrarFecha(solicitudPoliza.poliza?.fechaVencimiento)"/>
                </ca-form-field>
            </div>           
        </div>
    </ca-card>

    <div class="mt-4">
        <ca-tabs-group>
            <ca-tab label="{{'DATOS_SOLICITUD.CLIENTE.TITULO' | translate}}">
                <app-datos-cliente [poliza]="solicitudPoliza.poliza"></app-datos-cliente>
            </ca-tab>
            <ca-tab label="{{'DATOS_SOLICITUD.ASEGURADOS.TITULO' | translate}}" *ngIf="solicitudPoliza.poliza?.riesgos">
                <app-datos-asegurados [riesgos]="solicitudPoliza.poliza?.riesgos"></app-datos-asegurados>
            </ca-tab>
            <ca-tab label="{{'DATOS_SOLICITUD.DATOS_SOLICITUD_ESTADOS.TITULO' | translate}}">
                <app-datos-solicitud-estados [mensajes]="solicitudPoliza.expedientes"></app-datos-solicitud-estados>
            </ca-tab>
        </ca-tabs-group>
    </div>

    <div class="mt-4">
        <div class="float-left">
            <button ca-button-secondary type="button" (click)="volver()" >            
                <ca-icon>chevron_left</ca-icon>
                {{'DATOS_SOLICITUD.BOTON_VOLVER' | translate}}
            </button>
        </div> 
        <div class="float-right">
            <button ca-button type="button" (click)="duplicado()">
                <ca-icon>library_add</ca-icon>
                {{'DATOS_SOLICITUD.BOTON_DUPLICADO' | translate}}</button>
        </div>  
    </div>
</div>
